import React from "react";
import useHover from "../hooks/useHover";
import { objectToArray } from "../misc/helperfuncs";

const DetailedGlobalActivitiy = ({
  active,
  open,
  saved,
  description,
  hoverDescription,
}) => {
  const hover = useHover(hoverDescription);
  const array = [
    { name: "active", number: active },
    { name: "open", number: open },
    { name: "saved", number: saved },
  ];
  return (
    <div className="divColumn" style={{ width: "80%" }} {...hover.divProps}>
      <div
        className="divRow"
        style={{
          width: "80%",
          justifyContent: "center",
          position: "relative",
          marginBottom: "5px",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            padding: "5px",
            borderRadius: ".5rem/.5rem",
            backgroundColor: "#2f2f2f",
            opacity: "0.8",
          }}
        />
        <div className="textBold" style={{ zIndex: 1, color: "white" }}>
          {description}
        </div>
      </div>
      <div
        className="divRow"
        style={{
          width: "100%",
          justifyContent: "space-around",
          marginTop: "5px",
        }}
      >
        {array.map((a, index) => {
          return <NumberHolder number={a.number} name={a.name} key={index} />;
        })}
      </div>
    </div>
  );
};

const NumberHolder = ({ number, name }) => {
  return (
    <div className="divColumn">
      <div className="divRow">
        <img src="/icons/icon_player.png" className="icon20" />
        <div className="textBold">{number}</div>
      </div>
      <div style={{ fontFamily: "Robot-Regular", fontStyle: "italic" }}>
        {name}
      </div>
    </div>
  );
};

export default DetailedGlobalActivitiy;
